import { TimeRange, toDateTimeStr } from '@mi-front/core';
import { Timer } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';
import { DurationForRange } from '../../../../components/date-time/DateTime';
import { StreamElContainerProps } from '../../../../components/stream/stream-el/StreamEl';

const StyledDuration = styled('div')(({ theme }) => ({
  fontSize: '0.75rem',
  lineHeight: '1.5rem',
  color: theme.palette.common.white,
  display: 'flex',
  marginLeft: theme.spacing(0.5),
}));

const StyledIcon = styled('div')(({ theme }) => ({
  padding: '0 0.5rem',
  background: theme.palette.primary.main, // $color-Aqua
  borderTopLeftRadius: '2px',
  borderBottomLeftRadius: '2px',
  width: '1.5rem',
}));

const StyledValue = styled('div')(({ theme }) => ({
  padding: '0 0.5rem',
  borderTopRightRadius: '2px',
  borderBottomRightRadius: '2px',
  width: '6.5rem',
  background: '#92e1fe', // $color-AquaLight
  color: theme.palette.text.primary, // $color-Black
}));

interface Props extends StreamElContainerProps {
  readonly range: TimeRange<number>;
}

export function DurationLabel({ elProps = {}, ...p }: Props) {
  const { from, to } = p.range;

  return (
    <StyledDuration className={classNames('label-duration')}>
      <StyledIcon>
        <Timer />
      </StyledIcon>
      <StyledValue>
        <DurationForRange from={toDateTimeStr(from)} to={toDateTimeStr(to)} />
      </StyledValue>
    </StyledDuration>
  );
}
